import React, { FC } from "react";
import classNames from "classnames";
import { TerminalAppearanceResponse } from "../../../../../types/Admin/TerminalAppearanceTypes";
import { ChildrenModeToggleToChildren } from "../../ChildrenMode/ChildrenMode";
import classes from "./NormalMode.module.scss";
import {
  checkIsCategory,
  elementsLocalization,
  getCitoCardStyle,
  getNormalTicketCircleStyle,
  getTicketName,
  isCitoTile,
  languageType,
  TerminalTicketItem,
} from "./terminalModeShared";

type NormalModeViewProps = {
  language: languageType;
  currentSectionsServices: TerminalTicketItem[];
  currentIndex: number;
  activeModal: boolean;
  isLoadingGetTicket: boolean;
  activeTicketId?: number;
  appearance?: TerminalAppearanceResponse;
  useCategoryGrid: boolean;
  showChildrenModeButton: boolean;
  hideChildrenModeToggle: boolean;
  showGreeting: boolean;
  greetingTitle: string;
  greetingSubTitle: string;
  onBack: () => void;
  onToggleChildrenMode: () => void;
  onCategoryClick: (item: TerminalTicketItem) => void;
};

export const NormalModeView: FC<NormalModeViewProps> = ({
  language,
  currentSectionsServices,
  currentIndex,
  activeModal,
  isLoadingGetTicket,
  activeTicketId,
  appearance,
  useCategoryGrid,
  showChildrenModeButton,
  hideChildrenModeToggle,
  showGreeting,
  greetingTitle,
  greetingSubTitle,
  onBack,
  onToggleChildrenMode,
  onCategoryClick,
}) => (
  <div className={classes.terminalModeContent}>
    {(currentIndex !== 0 || showGreeting) && (
      <>
        {currentIndex !== 0 && (
          <div className={classes.chooseServiceText}>
            <button onClick={onBack} className={classes.buttonBack}>
              <div className={classes.buttonBackArrow} />
              <span>{elementsLocalization.returnBtn[language]}</span>
            </button>
          </div>
        )}
        {currentIndex === 0 && showGreeting && (
          <div className={classes.chooseServiceText}>
            <div>
              <p>{greetingTitle}</p>
              <p>{greetingSubTitle}</p>
            </div>
          </div>
        )}
      </>
    )}

    {!hideChildrenModeToggle && showChildrenModeButton && (
      <ChildrenModeToggleToChildren
        show
        onToggle={onToggleChildrenMode}
      />
    )}

    <div
      className={classNames(classes.ticketList, {
        [classes.ticketListLargeIcons]: currentSectionsServices.length <= 3,
        [classes.ticketListSmallIcons]: currentSectionsServices.length > 3,
        [classes.isBackBtnActive]: currentIndex !== 0,
        [classes.ticketListCategoryGrid]: useCategoryGrid,
      })}
    >
      {currentSectionsServices.length > 0 &&
        currentSectionsServices.map(
          (ticket: TerminalTicketItem, index: number) => {
            const ticketName = getTicketName(ticket, language);
            const isBtnDisabled =
              (!ticket.isActiveNow && !checkIsCategory(ticket)) ||
              (isLoadingGetTicket && activeTicketId === ticket.id) ||
              activeModal;
            const isCategory = checkIsCategory(ticket);
            const isService = !isCategory;
            const isCito = isCitoTile(ticket);
            const hasItemIcon = Boolean(ticket.iconUrl);
            const hideSmallCircle =
              (isCito
                ? (appearance?.settings?.citoButtons?.hideOuterCircleSmall ??
                  appearance?.settings?.buttons?.hideOuterCircleSmall)
                : appearance?.settings?.buttons?.hideOuterCircleSmall) &&
              !isCategory;
            const hideSectionCircle =
              (appearance?.settings?.sectionButtons?.hideOuterCircleSmall ??
                appearance?.settings?.buttons?.hideOuterCircleSmall) &&
              isCategory;
            const shouldHideOuterCircle =
              !hasItemIcon &&
              (isCategory ? hideSectionCircle : hideSmallCircle);
            const ticketCircleStyle = getNormalTicketCircleStyle(
              ticket,
              isCategory,
            );

            return (
              <button
                className={classNames(classes.ticketCardContainer)}
                key={`${ticket.id}_${index}`}
                onClick={() => onCategoryClick(ticket)}
                disabled={isBtnDisabled}
              >
                <div
                  className={classNames({
                    [classes.active]: isService && ticket.isActiveNow,
                    [classes.ticketCardSmall]: !isCategory,
                    [classes.ticketCardLarge]: isCategory,
                    [classes.ticketCardCompact]: shouldHideOuterCircle,
                  })}
                  style={isCito ? getCitoCardStyle(appearance) : undefined}
                >
                  {!shouldHideOuterCircle && (
                    <div
                      className={classNames({
                        [classes.ticketOuterCircleSmall]: !isCategory,
                        [classes.ticketOuterCircleLarge]: isCategory,
                      })}
                      style={ticketCircleStyle}
                    />
                  )}
                  <div className={classes.ticketTextWrapper}>
                    <div
                      className={classNames(classes.ticketTextScroll, {
                        [classes.ticketTextScrollSection]: isCategory,
                      })}
                    >
                      <span>{ticketName}</span>
                    </div>
                  </div>
                  <div
                    className={classNames({
                      [classes.cropLineShow]: !isCategory,
                      [classes.cropLineHide]: isCategory,
                    })}
                  />
                </div>
              </button>
            );
          },
        )}
    </div>
  </div>
);
